import React from 'react';
import Placeholder from '@atlassian/jira-placeholder/src/index.tsx';
import { lazy, type LazySuspenseProps } from '@atlassian/react-loosely-lazy';
import type { Props as CreateReleaseModalProps } from './index.tsx';

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const LazyCreateReleaseModal = lazy(() =>
	import(/* webpackChunkName: "async-create-release-modal" */ './index').then(
		(module) => module.CreateReleaseModal,
	),
);

export const CreateReleaseModal = ({
	fallback = null,
	...props
}: CreateReleaseModalProps & { fallback?: LazySuspenseProps['fallback'] }): React.JSX.Element => (
	<Placeholder name="create-release-modal" fallback={fallback}>
		<LazyCreateReleaseModal {...props} />
	</Placeholder>
);
